"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnprocessableEntity = void 0;
const ResponseError_1 = require("./ResponseError");
class UnprocessableEntity extends ResponseError_1.ResponseError {
    constructor(options) {
        super(options);
        this.name = this.constructor.name;
        this.message = this.message || UnprocessableEntity.label;
        this.type = UnprocessableEntity.type;
        this.statusCode = UnprocessableEntity.statusCode;
        Error.captureStackTrace(this, UnprocessableEntity);
    }
}
exports.UnprocessableEntity = UnprocessableEntity;
UnprocessableEntity.type = 'UnprocessableEntity';
UnprocessableEntity.label = 'Unprocessable Entity';
UnprocessableEntity.statusCode = 422;
//# sourceMappingURL=UnprocessableEntity.js.map